import script from "./PrintTaskCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintTaskCenter.vue?vue&type=script&setup=true&lang=js"

import "./PrintTaskCenter.vue?vue&type=style&index=0&id=6f87dc31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f87dc31"]])

export default __exports__